/**
 * DEPRECATED: This component is used for the /LiveVideoStreaming route (without playlistId)
 * For the main streaming functionality, use Streaming.js instead
 * TODO: Consider consolidating these two components
 */
import React, { useContext, useRef } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";
import AgoraRTM from "agora-rtm-sdk";
import { Box, IconButton, Snackbar, Stack, Typography } from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import "./index.scss";
import {
  beep,
  fullName,
  getErrorString,
  getUserDetail,
  getUserId,
  isMobile,
  isOwnerId,
  putRecors,
  screenWidth,
} from "../../constants/function";
import StreamHeader from "../../components/Stream/AudiencCardContainer/StreamHeader";
import StreamTippers from "../../components/Stream/AudiencCardContainer/StreamTippers";
import StreamingControls from "../../components/Stream/StreamingControls";
import { useDispatch } from "react-redux";
import { leaveStream, startStream } from "./../../action/stream";
import { SocketContext } from "../../context/socket";
import cookieStorage from "../../services/cookie-storage";
import { Images } from "../../assets/common";
import TopListPopup from "../../components/TopListPopup";
import SuccessPopup from "../../components/SuccessPopup";
import notifier from "../../components/Notifier";
import { useEffect } from "react";
import Loader from "../../components/Loader";
import TipPopup from "../../components/TipPopup";
import ApiService from "../../services/api-service";
import { getBalance } from "../../asyncAction/asyncBalance";
import NftList from "../../components/DirectChat/nftList";
import PanToolIcon from "@mui/icons-material/PanTool";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory, useParams } from "react-router-dom";
import * as io from "socket.io-client";
import { SERVER_URL } from "./../../constants/api";
import { useTranslation } from "react-i18next";
var remoteUsers = {};
var rtc = {
  client: null,
  joined: false,
  published: false,
  localStream: null,
  remoteStreams: [],
  params: {},
};
var rtc_screen = {
  client: null,
  isVideo: true,
  published: false,
  localStream: null,
  remoteStreams: [],
  params: {},
};
// Options for joining a channel
var option = {
  appId: "1d8d22987b394e23a9938498b6f28c04",
  channel: "",
  uid: null,
  token: null,
  key: "",
  secret: "",
  role: "host",
};
var remoteUsers = {};
var isLoggedIn = false;
var streamDataLocal = null;
var isOwner = false;
var on = false;
AgoraRTC.enableLogUpload();
AgoraRTC.setLogLevel(1);
rtc.client = AgoraRTC.createClient({ mode: "live", codec: "vp8" });

function LiveVideoStreaming({
  streamData,
  title,
  goal,
  isNew,
  goalDescription,
}) {
  const { t } = useTranslation("common");
  const [socket, setSocket] = React.useState(null);
  // const { setSocket } = useContext(SocketContext);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  const referralId = params.get("referralId");
  // const { playlistId } = useParams();
  const playlistId = params.get("playlistId");
  const [raisedList, setRaisedList] = React.useState([]);
  const [raisedUser, setRaisedUser] = React.useState({});
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [showNft, setShowNft] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const userId = getUserId();
  const [openTip, setOpenTip] = React.useState(false);
  const [openGift, setOpenGift] = React.useState(false);
  const [userData, setUserData] = React.useState({});
  const [success, setSuccess] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [tokenData, setTokenData] = React.useState({});
  const [liveUser, setLiveUser] = React.useState([]);
  // const socket = useContext(SocketContext).Socket;
  const dispatch = useDispatch();
  const [isVideo, setIsVideo] = React.useState(true);
  const [isMute, setIsMute] = React.useState(false);
  const [hostMuted, setHostMuted] = React.useState(false);
  const [video, setVideo] = React.useState(true);
  const [mode, setMode] = React.useState("video");

  const token = cookieStorage.getCookie("Authorization");
  const [isLive, setLive] = React.useState(false);
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const [tippers, setTippers] = React.useState(false);
  const [audienceRole, setAudienceRole] = React.useState({});
  const [audienceIndex, setAudienceIndex] = React.useState(null);
  const [role, setRole] = React.useState("");
  const Uid = useRef(null);
  const [isJoined, setIsJoined] = React.useState(false);
  const userDetail = getUserDetail();
  const liveUserRef = useRef([]);
  const [message, setMessage] = React.useState(null);
  React.useEffect(() => {
    streamDataLocal = streamData;
    isOwner = isOwnerId(streamData?.nftOwner?.owner || streamData?.owner);
    console.log("Streaming component - isOwner:", isOwner, "streamData owner:", streamData?.nftOwner?.owner || streamData?.owner, "current user:", getUserId());
    console.log("Full streamData object:", streamData);
    console.log("StreamData createdBy:", streamData?.createdBy);
    const path = history.location.pathname;
    if (streamDataLocal) {
      // Check if stream was already started via REST API (has token/channelName from backend)
      const isAlreadyStarted = streamDataLocal.token && streamDataLocal.channelName;
      
      if (!isAlreadyStarted) {
        // Old flow - start stream via socket (for music index compatibility)
        const payload = {
          channelName: streamDataLocal._id,
          role: isOwner ? "host" : "audience",
          JWT: token,
          platform: "web",
        };
        if (isOwner) {
          payload.goalAmount = goal;
          payload.goalTitle = title;
          payload.goalDescription = goalDescription;
          payload.isNew = isNew;
        }
        console.log("Stream payload:", payload);
        socket.emit("stream-start", payload);
      } else {
        // New flow - stream already started via REST API, just set up the Agora connection
        console.log("Stream already started via REST API, skipping socket stream-start");
        setupAgoraForExistingStream();
      }
    } else if (
      playlistId &&
      path.includes("/LiveVideoStreaming")
      // &&
      // isMobile.any()
    ) {
      const streamingContainer = document.getElementById(
        "__streaming_container"
      );
      streamingContainer.className += " _webview_streaming";
      const token = params.get("token");
      if (token) {
        const skt = io.connect(SERVER_URL, {
          auth: { JWT: token },
          transports: ["websocket"],
          reconnection: true,
        });
        setSocket(skt);

        getUserProfile(token, skt);
      }
    } else if (!history.location.pathname.includes("/LiveVideoStreaming")) {
      history.push("/app/Home");
      window.location.reload();
    }
    // return () => {
    //   if (rtc.client) endStream();
    // };
  }, [streamData]);

  const getUserProfile = async (token, socket) => {
    try {
      setLoading(true);
      setMessage(t("loader.message17"));
      const response = await ApiService.USER_PROFILE(token);

      localStorage.setItem(
        "isWhiteListed",
        response["result"]["isWhiteListed"]
      );

      const userData = { userData: response.result };
      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("token", token);
      cookieStorage.createCookie("Authorization", token, 1);
      localStorage.setItem(
        "isWhiteListed",
        response["result"]["isWhiteListed"]
      );

      setLoading(false);
      setMessage(null);
      if (window.location.href.includes("referralId="))
        putRecors({
          id: response["result"]._id,
          referralLink: window.location.href,
          eventType: ["sharedInbound"],
          eventAsset: playlistId,
          sharedBy: fullName(response["result"]),
          eventValue: ["Livestream"],
          socialMedia: null,
          referralId: referralId,
        });
      getPlaylistDetail(playlistId, token, socket);
    } catch (error) {
      setMessage(null);
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getPlaylistDetail = async (channelName, token, socket) => {
    try {
      setLoading(true);
      setMessage(t("loader.message18"));
      if (socket) setMessage(t("loader.message19"));
      else setMessage(t("loader.message20"));
      const goal = params.get("goal");
      const title = params.get("title");
      const isNew = params.get("isNew") === "true";
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: channelName,
        pageNo: 1,
        pageSize: 1,
      });

      isOwner = isOwnerId(response?.result?.nftOwner?.owner);

      streamDataLocal = response?.result;
      const payload = {
        channelName: streamDataLocal._id,
        role: isOwnerId(response?.result?.nftOwner?.owner)
          ? "host"
          : "audience",
        JWT: token,
        platform: "web",
      };
      if (isOwnerId(response?.result?.nftOwner?.owner)) {
        payload.goalAmount = goal;
        payload.goalTitle = title;
        payload.goalDescription = goalDescription;
        payload.isNew = isNew;
      }
      setMessage(null);
      if (socket) socket.emit("stream-start", payload);

      setLoading(false);
    } catch (error) {
      setMessage(null);
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      return response?.result?.isBlocked;
    } catch (error) {
      return null;
    }
  };
  React.useEffect(() => {
    // Listening live users joined the streaming
    if (socket) {
      socket.on("audience-in-stream", function (data) {
        if (
          data &&
          data.liveUsers &&
          data.channelName === streamData?._id
        ) {
          setLiveUser([...data.liveUsers]);
          liveUserRef.current = data.liveUsers;
          // const foundIndex = findCoHost(data.liveUsers);
          // if (foundIndex >= 0) {
          //   mute(!data?.liveUsers[foundIndex]?.user.mic);
          // }
        } else if (data && data.channelName === streamDataLocal._id) {
          setLiveUser([]);
        }
      });
      // Listingin for token
      socket.on("stream-joined", function (data) {
        const userId = getUserId();
        if (data.userId === userId) {
          option.token = data.token;
          option.appId = data.appId;
          setTokenData({ ...data });
          if (
            streamDataLocal._id &&
            isOwner &&
            rtc.client &&
            data.channelName === streamDataLocal._id &&
            data.userId === userId
          ) {
            setRole("host");
            joinChannel("host", streamDataLocal._id, "video", data.appId);
            setLive(true);
          } else if (
            streamDataLocal._id &&
            !isOwner &&
            rtc.client &&
            data.channelName === streamDataLocal._id &&
            data.userId === userId
          ) {
            setRole("audience");
            joinChannel("audience", streamDataLocal._id, "video", data.appId);
            // if (data.songStream) {
            //   socket.emit("song-start", data.songStream);
            // }
          }
        }
      });
      // Listening for stream end so that audience live stream window can closed automatically
      socket.on("stream-ended", function (data) {
        const userId = getUserId();
        if (
          data.channelName === streamDataLocal._id &&
          data.role === "host" &&
          isOwner &&
          data.userId === userId
        ) {
          setSuccess(true);
          // rtc.client = null;
        } else if (
          data.channelName === streamDataLocal._id &&
          data.role === "host"
        ) {
          setSuccess(true);
        }
      });
      socket.once("stream-error", function (data) {
        // console.log("Streaming-----------------------------");
        const userId = getUserId();
        if (
          data.channelName === streamDataLocal._id &&
          data.userId === userId &&
          rtc.client
        ) {
          //if audience try to join streaming twice it will throw error

          notifier.error(data.message);
          if (
            playlistId &&
            history.location.pathname.includes("/LiveVideoStreaming")
          ) {
            // if (isMobile.iOS())
            //   window.location.replace(
            //     "https://apps.apple.com/us/app/siki-io/id1564875912"
            //   );
            // if (isMobile.Android())
            //   window.location.replace(
            //     `intent://${window.location.origin}/#Intent;scheme=https;package=com.siki.app;end`
            //   );
            window.location.replace(window.location.origin + "/app/Home");
            // window.location.reload();
          } else dispatch(leaveStream());
        }
      });
      socket.on("makeCoHost", function (data) {
        if (
          data.userId === userId &&
          data.channelName === streamDataLocal._id &&
          !isOwner
        ) {
          // if (history.location.pathname.includes("/LiveVideoStreaming")) {
          // } else
          changeToHost(data.userId, data.role, data.host);
        }
      });
      //handleling raised hand by audience
      // socket.on("raised", function (data) {
      //   if (isOwner && data.channelName === streamDataLocal._id) {
      //     setRaisedUser({ ...data });
      //     const tempUser = raisedList;
      //     const index = findOne(data.user.userId);
      //     if (index >= 0) {
      //       tempUser.splice(index, 1);

      //       setRaisedList([...tempUser]);
      //     } else {
      //       tempUser.unshift(data);
      //       setOpenSnackbar(true);
      //       setRaisedList([...tempUser]);
      //       beep();
      //     }
      //   }
      // });
      socket.on("muted", function (data) {
        if (
          !isOwner &&
          data.channelName === streamDataLocal._id &&
          data.userId === userId
        ) {
          mute(!data.mic ? true : false, true);

          socket.emit("stream-invite", {
            userId: data.userId,
            channelName: streamDataLocal._id,
            role: "host",
            mic: data.mic,
            mutedBy: "host",
          });
        }
      });
      // socket.on("blocked", function (data) {
      //   if (data.roomId === streamDataLocal._id && data.status === "blocked") {
      //     const index = findOne(data.userId);
      //     if (index >= 0) {
      //       const tempUser = raisedList;
      //       tempUser.splice(index, 1);

      //       setRaisedList([...tempUser]);
      //     }
      //   }
      // });
    }
  }, [socket, streamData]);
  function findOne(_id) {
    return raisedList.findIndex((u) => u.user.userId === _id);
  }

  useEffect(() => {}, []);

  const setupAgoraForExistingStream = async () => {
    try {
      if (streamDataLocal && streamDataLocal.appId) {
        setRole(isOwner ? "host" : "audience");
        joinChannel(
          isOwner ? "host" : "audience", 
          streamDataLocal._id, 
          "video", 
          streamDataLocal.appId
        );
        setLive(true);
      } else {
        console.error("Missing appId in streamData for Agora setup");
      }
    } catch (error) {
      console.error("Error setting up Agora for existing stream:", error);
    }
  };

  async function joinChannel(role, channel, mode, appId, coHost) {
    try {
      // Create a client

      // Initialize the client
      // Create an audio track from the audio sampled by a microphone.

      if (role === "audience") {
        rtc.client.on("user-published", handleUserPublished);
        rtc.client.on("user-joined", handleUserJoined);
        rtc.client.on("user-left", handleUserLeft);
        rtc.client.on("user-unpublished", handleUnPublised);
        rtc.client.on("volume-indicator", handleVolume);
      }
      await rtc.client.setClientRole(role);
      // Initialize the client
      const uid = await rtc.client.join(appId, channel, option.token, null);
      option.uid = uid;
      socket.emit("stream-update", {
        channelName: streamDataLocal._id,
        role: isOwner ? "host" : "audience",
        uid: uid,
        userId: userId,
      });
      rtc.client.enableAudioVolumeIndicator();

      if (role === "host") {
        try {
          rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
            // Set the encoder configurations. For details, see the API description.
            encoderConfig: "1080p_5",
            optimizationMode: "detail",
            bitrateMax: 4780,
            bitrateMin: 65,
            frameRate: { max: 60, min: 5 },
            height: { max: 1280, min: 720 },
            width: { max: 1920, min: 720 },
          });

          // Create a video track from the video captured by a camera.
        } catch (error) {
          notifier.error(getErrorString(error) + "camera issue");
        }
        try {
          rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
            encoderConfig: "high_quality_stereo",
            bitrate: 192,
            sampleRate: 48,
            stereo: true,
          });
        } catch (error) {
          notifier.error(getErrorString(error) + "mic issue");
        }
        // if (!coHost)
        await rtc.client.publish(rtc.localAudioTrack);
        await rtc.client.publish(rtc.localVideoTrack);

        const isDiv = document.getElementById(`local_stream${uid}`);
        const playerContainer = document.getElementById(
          "local_stream_container"
        );
        const el = document.createElement("div");
        if (!isDiv) {
          el.id = `local_stream${uid}`;
          //add thumnail img if no video present
          const noVideo = document.createElement("div");
          const img = document.createElement("img");
          noVideo.className = "_no_video";
          noVideo.id = `_no_video${uid}`;
          const foundUser = findUid(uid);
          if (foundUser && foundUser?.user)
            img.src =
              foundUser?.user?.profileImg?.filePath ||
              Images.default_user_square;
          else
            img.src =
              userDetail?.profileImg?.filePath || Images.default_user_square;
          noVideo.appendChild(img);
          el.appendChild(noVideo);

          rtc.localVideoTrack.play(el);
          const pin = document.createElement("img");
          pin.src = Images.pin;
          pin.title = "pin to center";
          pin.id = `pin${uid}`;
          pin.addEventListener("click", function (element) {
            const cohost = document.getElementById("cohost_video_box");
            if (cohost) {
              playerContainer.firstChild.className = "_un_pin_";
            }
            cohost.appendChild(playerContainer.firstChild);
            document
              .getElementById("cohost_video_box")
              .children.forEach((e, index) => {
                let child;
                for (let index = 0; index < e.children.length; index++) {
                  const el = e.children[index];
                  if (el.id === element.target.id) {
                    child = el;
                    break;
                  }
                }
                if (child && element.target.id === child.id) {
                  e.className = "_pin_";
                  playerContainer.insertBefore(e, cohost);
                } else {
                  // playerContainer.children[index].className = "_un_pin_";
                  e.className = "_un_pin_";
                }
              });
          });
          pin.className = "_pin_class";
          el.appendChild(pin);
          if (playerContainer && playerContainer.children.length === 0) {
            el.className = "_pin_";
            playerContainer.appendChild(el);
          } else {
            const cohostlist = document.createElement("div");
            const isCoHosts = document.getElementById("cohost_video_box");
            if (!isCoHosts) {
              cohostlist.id = "cohost_video_box";
              el.className = "_un_pin_";
              cohostlist.appendChild(el);
              // if (history.location.pathname.includes("/LiveVideoStreaming")) {
              //   playerContainer.style.gridTemplateColumns = "1fr";
              //   playerContainer.style.gridTemplateRows = "160px 1fr";
              //   const pin = document.getElementsByClassName("_pin_");
              //   if (pin) pin[0].style.gridRows = "2";
              // } else
              playerContainer.style.gridTemplateColumns = "1fr 160px";
              playerContainer.appendChild(cohostlist);
            } else {
              el.className = "_un_pin_";
              isCoHosts.appendChild(el);
            }
          }
        }

        rtc.client.on("user-published", handleUserPublished);
        rtc.client.on("user-joined", handleUserJoined);
        rtc.client.on("user-left", handleUserLeft);
        rtc.client.on("user-unpublished", handleUnPublised);
        rtc.client.on("volume-indicator", handleVolume);
        rtc.client.on("media-reconnect-start", function (user) {
          console.log(user);
        });
        rtc.client.on("media-reconnect-end", function (user) {
          console.log(user);
        });
        setIsJoined(true);
      }
    } catch (error) {
      // notifier.error(getErrorString(error));
      dispatch(leaveStream());
    }
  }

  //show who is speaming in stream
  async function handleVolume(volumes) {
    volumes.forEach((volume) => {
      const user = document.getElementById(`local_stream${volume.uid}`);
      const users = document.getElementById("local_stream_container");

      for (let index = 0; index < users.children.length; index++) {
        const element = users.children[index];
        if (element.id === `local_stream${volume.uid}` && volume.level > 0) {
          if (user && !document.getElementById(`speaking${volume.uid}`)) {
            const img = document.createElement("img");
            img.id = `speaking${volume.uid}`;
            img.src = Images.speaking;

            user.style.position = "relative";
            img.className = "_speaking";
            user.appendChild(img);
          }
        } else if (
          element.id === `local_stream${volume.uid}` &&
          user &&
          user.children.length > 1
        ) {
          if (document.getElementById(`speaking${volume.uid}`))
            document.getElementById(`speaking${volume.uid}`).remove();
        }
      }
    });
  }
  async function handleUnPublised(user, mediaType) {
    if (mediaType === "video") {
      const id = user.uid;
      delete remoteUsers[id];
      if (!user.hasVideo && user?._video_added_) {
      } else {
        const local_stream = document.getElementById(`local_stream${id}`);
        if (local_stream) local_stream.remove();
        const cohost = document.getElementById("cohost_video_box");
        const playerContainer = document.getElementById(
          "local_stream_container"
        );
        if (cohost && cohost.children.length === 0) {
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer.children.length === 1 &&
          cohost &&
          cohost.children.length === 0
        ) {
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer.children.length > 1 &&
          cohost &&
          cohost.children.length === 0
        ) {
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer.children.length === 1 &&
          cohost &&
          cohost.children.length === 1
        ) {
          cohost.firstChild.className = "_pin_";
          playerContainer.insertBefore(cohost.firstChild, cohost);
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer.children.length === 1 &&
          cohost &&
          cohost.children.length > 1
        ) {
          cohost.firstChild.className = "_pin_";
          cohost.firstChild.style.gridRows = "1";
          playerContainer.insertBefore(cohost.firstChild, cohost);
        }
      }
    }
  }

  async function handleUserPublished(user, mediaType) {
    const id = user.uid;
    remoteUsers[id] = user;
    subscribe(user, mediaType);
  }
  function handleUserJoined(user, mediaType) {
    const id = user.uid;
    remoteUsers[id] = user;
    subscribe(user, mediaType);
  }
  function handleUserLeft(user) {
    const id = user.uid;
    delete remoteUsers[id];

    if (!user.hasVideo && user?._video_added_) {
    } else {
      const local_stream = document.getElementById(`local_stream${id}`);
      if (local_stream) local_stream.remove();
      const cohost = document.getElementById("cohost_video_box");
      const playerContainer = document.getElementById("local_stream_container");
      if (cohost && cohost.children.length === 0) {
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer.children.length === 1 &&
        cohost &&
        cohost.children.length === 0
      ) {
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer.children.length > 1 &&
        cohost &&
        cohost.children.length === 0
      ) {
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer.children.length === 1 &&
        cohost &&
        cohost.children.length === 1
      ) {
        cohost.firstChild.className = "_pin_";
        playerContainer.insertBefore(cohost.firstChild, cohost);
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer.children.length === 1 &&
        cohost &&
        cohost.children.length > 1
      ) {
        cohost.firstChild.className = "_pin_";
        cohost.firstChild.style.gridRows = "1";
        playerContainer.insertBefore(cohost.firstChild, cohost);
      }
    }
  }
  async function subscribe(user, mediaType) {
    if (mediaType) await rtc.client.subscribe(user, mediaType);
    if (mediaType === "video") {
      if (!Uid.current) Uid.current = user.uid;
      // if (isOwner) {
      const isDiv = document.getElementById(`local_stream${user.uid}`);
      const playerContainer = document.getElementById("local_stream_container");
      playerContainer.style.width = "90%";
      const el = document.createElement("div");
      let isplayer;
      if (isDiv)
        isDiv.children.forEach((e, index) => {
          if (e.id.includes("agora-video-player-track-video")) isplayer = true;
        });
      if (isDiv && !isplayer) {
        user.videoTrack.play(isDiv);
      } else if (!isDiv) {
        el.id = `local_stream${user.uid}`;
        const noVideo = document.createElement("div");
        const img = document.createElement("img");
        noVideo.className = "_no_video";
        noVideo.id = noVideo.id = `_no_video${user.uid}`;
        const foundUser = findUid(user.uid);
        if (foundUser && foundUser?.user)
          img.src =
            foundUser?.user?.profileImg?.filePath || Images.default_user_square;
        else img.src = Images.default_user_square;
        noVideo.appendChild(img);
        el.appendChild(noVideo);
        user.videoTrack.play(el);
        el.className = "_un_pin_";
        const pin = document.createElement("img");
        pin.src = Images.pin;
        pin.id = `pin${user.uid}`;
        pin.title = "pin to center";
        pin.addEventListener("click", function (element) {
          const cohost = document.getElementById("cohost_video_box");
          if (cohost) {
            playerContainer.firstChild.className = "_un_pin_";
          }
          cohost.appendChild(playerContainer.firstChild);
          document
            .getElementById("cohost_video_box")
            .children.forEach((e, index) => {
              let child;
              for (let index = 0; index < e.children.length; index++) {
                const el = e.children[index];
                if (el.id === element.target.id) {
                  child = el;
                  break;
                }
              }
              if (child && element.target.id === child.id) {
                e.className = "_pin_";
                playerContainer.insertBefore(e, cohost);
              } else {
                // playerContainer.children[index].className = "_un_pin_";
                e.className = "_un_pin_";
              }
            });
        });
        pin.className = "_pin_class";
        el.appendChild(pin);
        if (playerContainer && playerContainer.children.length === 0) {
          el.className = "_pin_";
          playerContainer.appendChild(el);
        } else {
          const cohostlist = document.createElement("div");
          const isCoHosts = document.getElementById("cohost_video_box");
          if (!isCoHosts) {
            cohostlist.id = "cohost_video_box";
            el.className = "_un_pin_";
            cohostlist.appendChild(el);
            // if (history.location.pathname.includes("/LiveVideoStreaming")) {
            //   playerContainer.style.gridTemplateColumns = "1fr";
            //   playerContainer.style.gridTemplateRows = "160px 1fr";
            // } else
            playerContainer.style.gridTemplateColumns = "1fr 160px";
            playerContainer.appendChild(cohostlist);
          } else {
            el.className = "_un_pin_";

            isCoHosts.appendChild(el);
          }
        }
      }
    }

    // If the subscribed track is audio.
    if (mediaType === "audio") {
      // if (screenWidth() < 700) {
      //   const isDiv = document.getElementById(`local_stream${user.uid}`);
      //   if (isDiv) user.audioTrack.play(isDiv, { muted: true });
      // } else
      user.audioTrack.play();
    }
    // const isDiv = document.getElementById(`local_stream${user.uid}`);

    // if (
    //   isDiv &&
    //   isDiv.children.length > 1 &&
    //   document.getElementsByClassName("agora_video_player") &&
    //   screenWidth() < 700
    // ) {
    //   const unmute = document.createElement("img");
    //   unmute.src = Images.unmute;
    //   unmute.className = "taptostart";
    //   unmute.id = `unmute${user.uid}`;
    //   isDiv.appendChild(unmute);
    //   document.body.addEventListener("touchstart", function () {
    //     for (const key in remoteUsers) {
    //       if (remoteUsers[key]._audioTrack) {
    //         remoteUsers[key]._audioTrack.play(isDiv, { muted: false });
    //         unmute.remove();
    //       }
    //     }
    //   });
    //   // if (videoId)
    // }
  }
  function findUid(userUid) {
    for (let index = 0; index < liveUserRef.current.length; index++) {
      const element = liveUserRef.current[index];
      if (element.uid === userUid) {
        return element;
      }
    }
    return null;
  }

  //start screen share
  async function shareScreen(channel, token, appId) {
    try {
      rtc_screen.client = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
      // if (rtc.localAudioTrack) leaveEventHost('host');
      const uid = await rtc_screen.client.join(appId, channel, token, null);

      AgoraRTC.createScreenVideoTrack({
        // Set the encoder configurations. For details, see the API description.
        encoderConfig: "1080p_1",
        optimizationMode: "detail",
      }).then(async (localScreenTrack) => {
        rtc_screen.localScreenTrack = localScreenTrack;
        rtc_screen.uid = uid;
        await rtc_screen.client.publish([rtc_screen.localScreenTrack]);
        // if (
        //   liveUser.length > 0 &&
        //   audienceIndex !== null &&
        //   liveUser["audienceIndex"]?.user.role === "host"
        // ) {
        //   socket.emit("requestToCoHost", {
        //     userId: audienceRole._id,
        //     role: "audience",
        //     channelName: streamDataLocal._id,
        //     host: userId,
        //     joined: false,
        //   });
        //   setAudienceIndex(null);
        //   // setAudienceRole({});
        // }

        setIsVideo(false);
      });
    } catch (error) {
      // console.log(error, "********************");
    }
  }
  //end screen share
  async function leaveScreenShare(params) {
    rtc_screen.localScreenTrack.close();
    rtc_screen.client.unpublish(rtc.localScreenTrack, function (err) {
      // console.log("publish failed");
      console.error(err);
    });
    delete rtc_screen.localScreenTrack;

    rtc_screen.client.leave(function (ev) {
      // console.log(ev);
    });
    rtc_screen.isVideo = true;
    rtc_screen.client = null;
    const playerContainer = document.getElementById(
      `local_stream${rtc_screen.uid}`
    );
    if (playerContainer) playerContainer.remove();
    setIsVideo(true);
  }

  // pause mic
  function mute(isHostMuted, coHost) {
    if (rtc.localAudioTrack.enabled) rtc.localAudioTrack.setEnabled(false);
    else rtc.localAudioTrack.setEnabled(true);
    setIsMute((isMute) => !isMute);
    if (coHost) setHostMuted(isHostMuted); //host controlling cohost mute function
    if (!coHost) {
      socket.emit("stream-invite", {
        userId: userId,
        channelName: streamDataLocal._id,
        role: "host",
        mic: !rtc.localAudioTrack.enabled,
      });
    }
  }
  // mute video
  function disableVideo() {
    if (rtc.localVideoTrack.enabled) rtc.localVideoTrack.setEnabled(false);
    else rtc.localVideoTrack.setEnabled(true);
    const noVideo = document.getElementById(`_no_video${option.uid}`);
    if (noVideo)
      noVideo.style.zIndex = rtc.localVideoTrack.enabled ? "1" : "-1";
  }
  //Leave streaming Host
  async function leaveEventHost(params) {
    if (rtc.localAudioTrack) rtc.localAudioTrack.close();
    if (rtc.localVideoTrack) rtc.localVideoTrack.close();
    // if (rtc.client) {
    //   await rtc.client.unpublish();
    await rtc.client.leave();
    // }
    const playerContainer = document.getElementById("local_stream");
    if (playerContainer) playerContainer.remove();
  }

  //Leave streaming audience
  function leaveEventAudience(params) {
    rtc.client.leave(
      function () {
        // console.log("client leaves channel");

        return true;
        //……
      },
      function (err) {
        // console.log("client leave failed ", err);
        //error handling
        return false;
      }
    );
  }
  const handle = async (e) => {
    setIsFullScreen(e);
  };
  const handleTip = async (amount, id, type, currency) => {
    const userDetail = getUserDetail();
    if (amount) {
      if (openUser) setOpenUser(false);
      setOpenTip(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: "artist",
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);

        setLoading(false);
        // notifier.success(response["result"]);
        // setUserName(null);

        const msg = {
          isStreaming: true,
          roomId: streamDataLocal._id,
          senderUserId: userId,
          amount: amount,
          message: `${fullName(
            userDetail
          )} has tipped ${amount} ${currency.toUpperCase()} to  ${fullName(
            userData
          )}`,
          _id: userId,
          JWT: token,
          type: "tip",
        };

        socket.emit("chat_message", msg);
        //need roomId to send tip message to user
        const roomId = await getRoomId(userData._id, userDetail._id);
        if (roomId) {
          msg["user"] = {
            firstName: userData["firstName"],
            lastName: userData["lastName"],
            profileImg: userData["profileImg"],
            _id: userData["_id"],
          };
          msg["_id"] = new Date().getTime();
          msg["createdAt"] = new Date();
          msg.senderUserId = userDetail._id;
          msg.roomId = roomId;
          socket.emit("send", msg);
        }
        setUserData({});
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };

  const getRoomId = async (userId, senderUserId) => {
    try {
      const response = await ApiService.GET_ROOM_ID(
        `userId=${userId}&senderUserId=${senderUserId}`
      );
      return response?.result?.roomId;
    } catch (error) {
      return null;
    }
  };

  const requestToBeHost = (id, role) => {
    // if (role === "audience") leaveEventAudience();
    // else leaveEventAudience();
    option.role = option.role === "host" ? "audience" : "host";
    socket.emit("requestToCoHost", {
      userId: id,
      role: role,
      channelName: streamDataLocal._id,
      host: userId,
      joined: false,
    });
  };
  const changeToHost = (id, ROLE, host) => {
    setRole(ROLE);
    if (ROLE === "host") {
      // await leaveEventHost();
      rtc.client.setClientRole("host");
      joinChannel(
        ROLE,
        streamDataLocal._id,
        null,
        option.appId,
        ROLE === "audience" ? false : true
      );

      socket.emit("stream-invite", {
        userId: userId,
        channelName: streamDataLocal._id,
        role: "host",
        mic: true,
        changedToHost: true
      });
      setIsMute(false);
    } else if (ROLE === "audience") {
      leaveEventHost();
      rtc.client.setClientRole("host");
      joinChannel(
        ROLE,
        streamDataLocal._id,
        null,
        option.appId,
        ROLE === "audience" ? false : true
      );

      socket.emit("stream-invite", {
        userId: userId,
        channelName: streamDataLocal._id,
        role: "audience",
        mic: true
      });
    }
  };

  const endStream = (raised) => {
    // if (!isOwner && raised) {
    //   socket.emit("raise", {
    //     user: {
    //       userId: userId,
    //     },
    //     channelName: streamDataLocal._id,
    //   });
    //   if (raised) {
    //     setSuccess(true);
    //     return;
    //   }
    // }

    if (rtc.client) {
      if (rtc_screen.client) leaveScreenShare();
      socket.emit("stream-end", {
        channelName: streamDataLocal._id,
        role: isOwner ? "host" : "audience",
        JWT: token,
      });
      leaveEventHost("host");
      // if (isOwner && rtc.client)
      // else if (rtc.client) leaveEventAudience("audience");

      if (
        playlistId &&
        history.location.pathname.includes("/LiveVideoStreaming")
      ) {
        // history.push("/app/Home");
        // window.location.reload();
        // if (isMobile.iOS())
        //   window.location.replace(
        //     "https://apps.apple.com/us/app/siki-io/id1564875912"
        //   );
        // if (isMobile.Android())
        //   window.location.replace(
        //     `intent://${window.location.origin}/#Intent;scheme=https;package=com.siki.app;end`
        //   );
        window.location.replace(window.location.origin + "/app/Home");
      } else window.location.reload();
    }
  };
  const handleMute = (usr) => {
    socket.emit("mute", {
      userId: usr._id,
      channelName: streamDataLocal._id,
      mic: !usr.mic,
    });
  };
  return (
    <Box className="__streaming_container" id="__streaming_container">
      {/* Streaming header */}
      {tokenData?.token ? (
        <StreamHeader
          isJoined={isJoined}
          isOwner={isOwner}
          title={streamDataLocal?.title}
          leaveStreaming={() => endStream()}
          onCloseFullScreen={(e) => handle(e)}
          onNftClose={() => setShowNft(false)}
          playlistId={streamDataLocal._id}
        />
      ) : null}
      {/* Streaming top tippers and goals */}
      {/* {isOwner ? ( */}
      {tokenData?.channelName && socket ? (
        <StreamTippers
          isJoined={isJoined}
          isOwner={isOwner}
          liveUser={liveUser.length}
          goal={tokenData?.goal?.totalGoalAmount}
          title={tokenData?.goal?.goalTitle}
          goalDescription={tokenData?.goal?.goalDescription}
          channelName={streamDataLocal._id}
          goalProgress={tokenData?.goal?.goalProgress}
          setStreamTippers={(e) => setTippers(e)}
        />
      ) : null}
      {/* ) : null} */}
      {/* {isOwner ? ( */}
      <Box
        id="_streaming_canvas"
        className="_streaming_canvas"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          gap: liveUser.length > 0 ? "12px" : "0",
        }}
      >
        <div
          id="local_stream_container"
          className="local_stream_container"
          style={{
            position: "relative",
            width: liveUser.length === 0 ? "100%" : "86%",
            height:
              !tokenData?.goal?.totalGoalAmount && !tippers
                ? "calc(100% - 120px)"
                : tokenData?.goal?.totalGoalAmount || tippers
                ? "calc(100% - 220px)"
                : "calc(100% - 120px)",

            transition: "width 0.2s ease-in-out 0s",
          }}
        >
          {!tokenData?.channelName ? (
            <Loader
              wait={true}
              _class="__loader_inside"
              message={message ? message : t("loader.message23")}
            />
          ) : null}
        </div>
        {/* </div> */}

        <Box className="_streaming_audience" sx={{ zIndex: "100000" }}>
          {liveUser &&
            liveUser.slice(0, 4).map((u, index) => (
              <Box
                onClick={() => setOpenUser(true)}
                key={index}
                className="_streaming_audience_box"
                sx={{ backgroundColor: "#1E1E1E", cursor: "pointer" }}
              >
                <img
                  className="_streaming_audience_box_image"
                  src={
                    u?.user?.profileImg?.filePath || Images.default_user_square
                  }
                  alt=""
                />
                <Stack
                  className="_streaming_audience_box_user_detail"
                  direction="row"
                  spacing={1}
                >
                  <span className="_online"></span>
                  <Typography className="fs-9 light-text">
                    {fullName(u?.user, 15)}
                  </Typography>
                </Stack>
              </Box>
            ))}
          {liveUser.length > 4 ? (
            <Box
              className="_streaming_audience_box_more"
              onClick={() => setOpenUser(true)}
            >
              <Typography
                className="24 fw-b _cp"
                sx={{
                  height: "inherit",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                +{liveUser.length - 4}
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Box>

      {/* Streaming controls for HOST and AUDIENCE */}
      {console.log('StreamingControls render check:', { 
        hasToken: !!tokenData?.token, 
        hasSocket: !!socket,
        tokenData,
        shouldRender: !!(tokenData?.token && socket),
        role,
        isOwner,
        isJoined,
        streamDataLocal,
        streamDataLocalCreatedBy: streamDataLocal?.createdBy,
        streamDataLocalCreatedByDetails: streamDataLocal?.createdByDetails,
        streamData,
        streamDataCreatedBy: streamData?.createdBy
      })}
      {tokenData?.token && socket ? (
        <StreamingControls
          streamData={streamDataLocal}
          raisedList={raisedList}
          isJoined={isJoined}
          role={role}
          liveUser={liveUser.length}
          tokenData={tokenData}
          isOwner={isOwner}
          leaveStreaming={(raised) => {
            // leaveEventAudience("audience");
            if (raised) endStream(raised);
            else setSuccess(true);
          }}
          playlistId={streamDataLocal._id}
          title={streamDataLocal.title}
          hostId={streamDataLocal?.createdBy || streamDataLocal?.createdByDetails?._id || streamData?.createdBy || "61736afa0a4eff0de720b4aa"}
          mute={() => {
            mute(isMute);
            // setIsMute(!isMute);
          }}
          disableVideo={() => {
            disableVideo();
            setVideo(!video);
          }}
          isMute={isMute}
          hostMuted={hostMuted}
          video={video}
          isVideo={isVideo}
          shareScreen={(isShared) => {
            shareScreen(
              tokenData.channelName,
              tokenData.token,
              tokenData.appId
            );
            // setIsVideo(false);
          }}
          stopShare={() => {
            leaveScreenShare();
            // setIsVideo(true);
          }}
          onCloseFullScreen={(e) => handle(e)}
          isFullScreen={isFullScreen}
          hostId={streamData?.createdBy || streamDataLocal?.createdBy || "61736afa0a4eff0de720b4aa"}
          onAcceptSongRequest={(song) => {
            // Handle accepted song request - add to playlist
            console.log('Song request accepted:', song);
            // You can add logic here to add the song to the current playlist
          }}
        />
      ) : null}

      {/* {loading  ? (
        <Loader wait={true} _class="__loader_inside" message="sending tip..." />
      ) : null} */}
      {openUser ? (
        <TopListPopup
          isOwner={isOwner}
          isUsers={true}
          title={`${t("topListPopup.title3")} (${liveUser.length})`}
          open={openUser}
          data={liveUser}
          isArray={true}
          handleClose={() => setOpenUser(false)}
          isLiveUser={false}
          onTipPoupOpen={(e) => {
            setOpenTip(true);
            setUserData({ ...e });
          }}
          onNftPoupOpen={(e) => {
            setOpenUser(false);
            setShowNft(true);
            setUserData({ ...e });
          }}
          //making cohost to audience if making someone else cohost
          onRequestToHost={(id, index, user) => {
            // Remove already created co-host(only one cohost at a time)
            if (audienceIndex !== null && audienceIndex !== index) {
              requestToBeHost(liveUser[audienceIndex].user._id, "audience");
            }
            requestToBeHost(id, user.role === "audience" ? "host" : "audience");
            setAudienceIndex(index);
            setOpenUser(false);
          }}
          onHandleMute={(usr) => {
            handleMute(usr);
            setOpenUser(false);
          }}
        />
      ) : null}
      {showNft ? (
        <NftList
          style={{ right: "0", width: "444px", zIndex: 100000 }}
          onClose={() => {
            setShowNft(false);
            setUserData({});
          }}
          fullName={fullName(userData)}
          toUser={userData._id}
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={fullName(userData)}
          id={userData._id}
          open={openTip}
          isArtist={true}
          isPlaylist={false}
          handleClose={handleTip}
        />
      ) : null}
      {success ? (
        <SuccessPopup
          open={success}
          message={t("success.message6")}
          handleClose={() => {
            endStream();
            // dispatch(leaveStream());
          }}
        />
      ) : null}
      {openSnackbar ? (
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setOpenSnackbar(false);
            setRaisedUser({});
          }}
          TransitionComponent={Slide}
        >
          <Stack
            className={
              "_open_snackbar" +
              (raisedUser?.user?.userId ? " _open_snackbar_width" : "")
            }
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <PanToolIcon sx={{ fontSize: "15px" }} />
            <Typography className="fs-14">
              {fullName(raisedUser?.user)}
            </Typography>
            <IconButton
              sx={{ marginLeft: "auto !important" }}
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => {
                setOpenSnackbar(false);
                setRaisedUser({});
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Snackbar>
      ) : null}
    </Box>
  );
}

export default LiveVideoStreaming;
